<!-- src/components/pages/en/LandingEN.vue -->
<template>
  <div class="landing-page">
    <MenubarEN :scrollToSection="scrollToSection" />

    <section ref="profile" id="profile"><PerfilEN /></section>
    <section ref="about" id="about"><LogrosEN /></section>
    <section ref="services" id="services"><ServiciosEN /></section>
    <section ref="results" id="results"><TrayectoriaEN /></section>

    <FooterEN />

    <!-- 👇 Chat en versión inglés -->
    <ChatBotEA
      lang="EN"
      :company="companyEN"
      :socials="socials"
      :services="servicesEN"
      :hours="hoursEN"
      :coverage="coverageEN"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'

/* ⚠️ Usa rutas absolutas con @ para evitar errores de paths relativos */
import MenubarEN from '@/components/pages/en/menubarEN.vue'
import PerfilEN from '@/components/pages/en/perfilEN.vue'
import LogrosEN from '@/components/pages/en/LogrosEN.vue'
import ServiciosEN from '@/components/pages/en/ServiciosEN.vue'
import TrayectoriaEN from '@/components/pages/en/TrayectoriaEN.vue'
import FooterEN from '@/components/pages/en/footerEN.vue'

/* ✅ Importa el chatbot desde donde lo guardaste.
   Recomendado: src/components/ChatBotEA.vue */
import ChatBotEA from '@/components/pages/es/ChatBotEA.vue'

const profile = ref(null)
const about = ref(null)
const services = ref(null)
const results = ref(null)

const scrollToSection = (section) => {
  const sectionsMap = { profile, about, services, results }
  const target = sectionsMap[section]?.value
  if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

const onScrollEvent = (e) => {
  const id = e.detail?.id
  if (!id) return
  // Mapear ids ES -> EN si llegan desde otra vista
  const mapEStoEN = { perfil: 'profile', logros: 'about', servicios: 'services', trayectoria: 'results' }
  const targetId = mapEStoEN[id] || id
  const el = document.getElementById(targetId)
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

onMounted(async () => {
  window.addEventListener('scroll-to-section', onScrollEvent)

  // Si guardaron un destino previo en localStorage
  const saved = localStorage.getItem('scrollTarget')
  if (saved) {
    localStorage.removeItem('scrollTarget')
    await nextTick()
    const mapEStoEN = { perfil: 'profile', logros: 'about', servicios: 'services', trayectoria: 'results' }
    const id = mapEStoEN[saved] || saved
    const el = document.getElementById(id)
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }
})

onBeforeUnmount(() => {
  window.removeEventListener('scroll-to-section', onScrollEvent)
})

/* 🔤 Props en inglés para el chat */
const companyEN = {
  name: 'EA Magic Cleaning LLC',
  phone: '(612) 261-9287',
  phoneHref: 'tel:+16122619287',
  email: 'eamagiccleaning@gmail.com',
  address: '11345 Deer Ridge Ln, Hopkins, MN 55343',
  maps: 'https://www.google.com/maps?q=11345%20Deer%20Ridge%20Ln%2C%20Hopkins%2C%20MN%2055343',
wa: 'sms:+16122619287?&body=Hello, I\'m interested in cleaning services'
}

const socials = {
  facebook: 'https://www.facebook.com/share/1EFrEHeDam/?mibextid=wwXIfr',
  tiktok: null
}

const servicesEN = [
  'House cleaning',
  'Apartment cleaning',
  'Post-construction cleaning',
  'Move-in/Move-out',
  'Deep cleaning',
  'Regular cleaning',
  'Office cleaning',
  'Church cleaning'
]

const hoursEN = {
  ES: 'Lun–Sáb 8:00 a 18:00. Domingos bajo cita.', // requerido por el componente
  EN: 'Mon–Sat 8:00 AM – 6:00 PM. Sundays by appointment.'
}

const coverageEN = {
  ES: 'Atendemos Hopkins, Minneapolis y alrededores en Minnesota.', // requerido por el componente
  EN: 'We serve Hopkins, Minneapolis, and surrounding areas in Minnesota.'
}
</script>

<style scoped>
.landing-page { width: 100%; overflow-x: hidden; }
section { scroll-margin-top: 80px; }
</style>
